import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09bf5b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ai-report-chat" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-muted p-4"
}
const _hoisted_3 = {
  class: "chat-thread",
  ref: "thread"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_5 = { class: "user-bubble text-end" }
const _hoisted_6 = {
  key: 0,
  class: "small text-muted mt-1"
}
const _hoisted_7 = {
  key: 1,
  class: "assistant-block"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "small text-muted mt-2" }
const _hoisted_10 = {
  key: 1,
  class: "alert alert-danger mb-0"
}
const _hoisted_11 = {
  key: 2,
  class: "assistant-bubble"
}
const _hoisted_12 = {
  key: 0,
  class: "text-center p-3"
}
const _hoisted_13 = { class: "chat-input d-flex mt-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportChartView = _resolveComponent("ReportChartView")!
  const _component_ReportTableView = _resolveComponent("ReportTableView")!
  const _component_pulse_loader = _resolveComponent("pulse-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.messages.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Ask a question about your financial data, e.g. \"Show me revenue by processor for the selected date range\" or \"How many users are currently on trial?\" "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (m, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "mb-4"
        }, [
          (m.role === 'user')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(m.content), 1),
                  (m.caption)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(m.caption), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (m.kind === 'result')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (m.chart)
                        ? (_openBlock(), _createBlock(_component_ReportChartView, {
                            key: 0,
                            chart: m.chart,
                            data: m.data
                          }, null, 8, ["chart", "data"]))
                        : _createCommentVNode("", true),
                      (m.table)
                        ? (_openBlock(), _createBlock(_component_ReportTableView, {
                            key: 1,
                            table: m.table,
                            data: m.data
                          }, null, 8, ["table", "data"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(m.rowCount) + " row(s) · " + _toDisplayString(m.executionTimeMs) + "ms", 1)
                    ]))
                  : (m.kind === 'error')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(m.content), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(m.content), 1))
              ]))
        ]))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_pulse_loader, {
              loading: _ctx.loading,
              color: "#1ebacb"
            }, null, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
        class: "form-control me-2",
        rows: "2",
        placeholder: "Ask a question...",
        disabled: _ctx.loading,
        onKeydown: [
          _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["exact","prevent"]), ["enter"])),
          _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onHistoryUp && _ctx.onHistoryUp(...args)), ["up"])),
          _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onHistoryDown && _ctx.onHistoryDown(...args)), ["down"]))
        ]
      }, null, 40, _hoisted_14), [
        [_vModelText, _ctx.draft]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        disabled: _ctx.loading || !_ctx.draft.trim().length,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
      }, "Send", 8, _hoisted_15)
    ])
  ]))
}